// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Table-module_mobile_HzUZW","card":"Table-module_card_3hloW","item":"Table-module_item_1ya7g"};